import React from 'react'
import { FieldOption, SousBlocOption } from "../../../types/ChampsObligatoires"
import { RequiredFieldStateCode } from "../../../enums/EtatChampObligatoire"
import AjoutChampForm from './AjoutChampForm'

interface TemplateFieldPayload {
    fieldId: number
    subBlockId: number | null
    type: string | null
    isCore: boolean
    defaultState: RequiredFieldStateCode
}

interface BlocAdminPanelProps {
    fields: FieldOption[]
    sousBlocsExistants: SousBlocOption[]
    showAjoutForm: boolean
    onShowAjoutForm: () => void
    onCancelAjoutForm: () => void
    onCreateField: (label: string, code: string) => Promise<FieldOption>
    onCreateSubBloc: (label: string) => Promise<{ id: number }>
    onAjoutSubmit: (payloads: TemplateFieldPayload[]) => Promise<void>
    editDraftsCount: number
    hasEmptyDraftLabel: boolean
    savingDetails: boolean
    onCancelAllEdits: () => void
    onSaveAllEdits: () => void
}

/**
 * Barre d'actions admin d'un bloc : ajout d'un champ au référentiel (BDREF3) et récapitulatif
 * des modifications de libellé/sous-bloc en attente d'enregistrement.
 */
export default function BlocAdminPanel({
    fields, sousBlocsExistants, showAjoutForm, onShowAjoutForm, onCancelAjoutForm,
    onCreateField, onCreateSubBloc, onAjoutSubmit,
    editDraftsCount, hasEmptyDraftLabel, savingDetails, onCancelAllEdits, onSaveAllEdits,
}: BlocAdminPanelProps) {
    return (
        <>
            {showAjoutForm ? (
                <AjoutChampForm
                    fields={fields}
                    sousBlocsExistants={sousBlocsExistants}
                    onCreateField={onCreateField}
                    onCreateSubBloc={onCreateSubBloc}
                    onSubmit={onAjoutSubmit}
                    onCancel={onCancelAjoutForm}
                />
            ) : (
                <button type="button" className="btn btn-outline-primary btn-sm mb-3" onClick={onShowAjoutForm}>
                    <i className="fa fa-plus mr-1" />Ajouter un champ
                </button>
            )}

            {editDraftsCount > 0 && (
                <div className="alert alert-info d-flex justify-content-between align-items-center py-2 mb-3">
                    <span>
                        <span className="badge badge-info mr-2">{editDraftsCount}</span>
                        modification{editDraftsCount > 1 ? 's' : ''} de champ non enregistrée{editDraftsCount > 1 ? 's' : ''}
                    </span>
                    <div>
                        <button type="button" className="btn btn-secondary btn-sm mr-2" disabled={savingDetails} onClick={onCancelAllEdits}>
                            Annuler
                        </button>
                        <button type="button" className="btn btn-eseller-color btn-sm" disabled={savingDetails || hasEmptyDraftLabel} onClick={onSaveAllEdits}>
                            {savingDetails ? 'Enregistrement...' : 'Enregistrer'}
                        </button>
                    </div>
                </div>
            )}
        </>
    )
}
